/**
 *  Load item's specification on PDP 'afterAppendView' event asynchrounsly
 **/
define('StellarGrade.ST_Product.ItemDetails.Specifications.View', [
    'StellarGrade.ST_Product.ItemDetails.Model.Specifications',
    'item_details_display_specs.tpl',
    'underscore',
], function (ItemSpecifications, item_details_display_specs_tpl, _) {
    'use strict';

    function processSpecs(specs) {
        var specsByMain = {};

        for (var i = 0; i < specs.length; i++) {
            var spec = specs[i];

            // Check if the main already exists in the specsByMain object
            if (specsByMain.hasOwnProperty(spec.main)) {
                // If the main exists, check if the sub already exists
                var existingSub = null;
                for (var j = 0; j < specsByMain[spec.main].length; j++) {
                    if (specsByMain[spec.main][j].sub === spec.sub) {
                        existingSub = specsByMain[spec.main][j];
                        break;
                    }
                }
                if (existingSub) {
                    // If the sub already exists, concatenate the new value with existing value
                    existingSub.details.push({ value: spec.details[0].value });
                } else {
                    // If the sub doesn't exist, create a new sub object and push it to the main
                    specsByMain[spec.main].push({ sub: spec.sub, details: [{ value: spec.details[0].value }] });
                }
            } else {
                // If the main doesn't exist, create a new array with the sub and details
                specsByMain[spec.main] = [{ sub: spec.sub, details: [{ value: spec.details[0].value }] }];
            }
        }

        var specsArray = [];
        for (var main in specsByMain) {
            if (specsByMain.hasOwnProperty(main)) {
                specsArray.push({ main: main, details: specsByMain[main] });
            }
        }

        return specsArray;
    }

    return Backbone.View.extend({
        template: item_details_display_specs_tpl,

        initialize: function () {
            var self = this;
            var dataPromise = this.options.asyncData && this.options.asyncData.specificationsPromise;
            this.specs = [];

            var itemId = this.options.itemID;

            this.displayName = this.options.displayName;

            if (dataPromise && self.options.asyncData.specificationsCollection) {
                dataPromise.done(function () {
                    self.model = self.options.asyncData.specificationsCollection.get('items').get(itemId);

                    if (self.model && !self.model.isNew()) {
                        self.setupSpecs();
                        self.render();
                    }
                });
            } else {
                this.model = new ItemSpecifications.model();
                this.model.searchApiMasterOptions = _.extend({}, this.model.searchApiMasterOptions, {
                    fieldset: 'specifications',
                });

                this.model
                    .fetch({
                        data: {
                            // item's id
                            id: itemId,
                        },
                    })
                    .done(function (res) {
                        self.setupSpecs();
                        self.render();
                    });
            }
        },

        setupSpecs: function () {
            var productSpecifications = this.model.get('custitem_sca_specs_json_long');
            if (productSpecifications) {
                productSpecifications = JSON.parse(productSpecifications);
                var specs = [];

                productSpecifications.forEach(function (specGroup) {
                    for (var mainCategory in specGroup) {
                        var main = mainCategory.replace('_', ' ').toUpperCase();
                        var details = specGroup[mainCategory];

                        if (details) {
                            for (var subCategory in details) {
                                var sub = subCategory.toLowerCase();
                                sub = subCategory.charAt(0).toUpperCase() + sub.slice(1);
                                var subDetails = details[subCategory];

                                if (typeof subDetails === 'string' && subDetails !== '') {
                                    subDetails = [subDetails];
                                }

                                if (typeof subDetails === 'object' && subDetails !== null) {
                                    for (var key in subDetails) {
                                        specs.push({
                                            main: main,
                                            sub: sub,
                                            details: [{ key: key, value: subDetails[key] }],
                                        });
                                    }
                                }
                            }
                        }
                    }
                });

                this.specs = specs;
            }
        },

        events: {
            'click #printButton': 'printSpecifications',
        },

        printSpecifications: function () {
            var specs = this.specs;
            if (!specs || specs.length === 0) {
                alert('No specifications available to print.');
                return;
            }
            var productName = $('.product-details-full-content-header-title').text().trim();
            var printWindow = window.open(productName, '_blank', 'width=800,height=600');

            var htmlContent = `
            <html>
                <head>
                    <title><Product Specifications - ${productName}</title>
                    <meta charset="utf-8">
                    <meta name="viewport" content="width=device-width, initial-scale=1">
                    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css">
                    <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js"></script>
                    <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/js/bootstrap.min.js"></script>

                    <style>
                        header {
                            height: 20px;
                        }
                        body {
                            font-family: Arial, sans-serif;
                            margin: 0;
                            padding: 20px;
                        }
                        h2 {
                            text-align: right;
                            font-size: 24px;
                            color: #333;
                            margin-bottom: 20px;
                        }
                        table {
                            width: 100%;
                            border-collapse: collapse;
                            margin-top: 20px;
                        }
                        th, td {
                            padding: 10px;
                            border: 1px solid #ddd;
                            text-align: left;
                        }
                        td {
                            vertical-align: top;
                        }
                        footer {
                            width: 100%;
                            font-size: 14px;
                            color: #555;
                            padding: 10px;
                            background: white;
                            position: fixed;
                            bottom: 0;
                            left: 0;
                            height: 30px;
                            display: flex;
                            justify-content: space-between; /* Align left and right content */
                        }

                        .footer-left {
                            text-align: left;
                        }

                        .footer-right {
                            text-align: right;
                        }
                        @media print {
                            body {
                                font-size: 12px;
                            }
                            table {
                                font-size: 14px;
                            }
                            footer {
                                position: fixed;
                                bottom: 0;
                                left: 0;
                            }
                            body {
                                padding-bottom: 50px; 
                            }
                        }
                        .main-category-header {
                            font-size: 18px;
                            font-weight: bold;
                            color: black;
                            padding: 10px;
                            text-align: center;
                            margin-top: 20px;
                            border-top: 2px solid #ddd;
                            border-bottom: 2px solid #ddd;
                            background-color: rgb(161, 161, 161); 
                            color: white;
                        }
                        .subcategory-header {
                            font-size: 16px;
                            font-weight: bold;
                            background-color:rgb(161, 161, 161);
                            color: white;
                            padding: 10px;
                            text-align: center;
                        }
                        .logo {
                            width: 300px;
                            height: auto;
                            margin-bottom: 20px;
                        }
                    </style>
                </head>
                <body>
                    <header>
                        <img src="https://shop.stealth.com/assets/stealth-logo-red.jpg" class="logo" alt="Stealth Logo">
                    </header>
                    <h2>${productName}</h2>
                    <table>
                        <tbody>`;

            var previousMain = null;
            var previousSub = null;

            for (var i = 0; i < specs.length; i++) {
                var main = specs[i].main;
                var sub = specs[i].sub;
                var details = specs[i].details;

                if (main !== previousMain) {
                    htmlContent += `
                    <tr>
                        <td colspan="2" class="main-category-header">${main}</td>
                    </tr>`;
                    previousMain = main;
                }

                for (var j = 0; j < details.length; j++) {
                    var subDetails = details[j].value || '';

                    if (sub !== previousSub) {
                        htmlContent += `
                            <tr>
                                <td class="subcategory-header" style="padding:10px; border:1px solid #ddd; vertical-align:top;">${sub}</td>
                                <td style="padding:10px; border:1px solid #ddd; vertical-align:top;">${subDetails}</td>
                            </tr>`;
                        previousSub = sub;
                    } else {
                        htmlContent += `
                            <tr>
                                <td style="padding:10px; border:1px solid #ddd; vertical-align:top;"></td>
                                <td style="padding:10px; border:1px solid #ddd; vertical-align:top;">${subDetails}</td>
                            </tr>`;
                    }
                }
            }

            htmlContent += `
                            </tbody>
                        </table>
                    </body>
                </html>`;

            printWindow.document.write(htmlContent);
            printWindow.document.close();

            printWindow.onload = function () {
                printWindow.print();
                printWindow.close();
            };
        },

        getContext: function () {
            return {
                itemsSpecs: processSpecs(this.specs),
                displayName: this.options.displayName,
            };
        },
    });
});
